import { useTypedQuery } from "hooks";
import { DealersDashboardQueryKeys } from "modules/DealersDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Dealer } from "models";

const collectLinkedAccounts = (dealers: Dealer[]) =>
  dealers.reduce((linkedAccounts, dealer) => {
    if (dealer.exact_account_id) linkedAccounts.set(dealer.exact_account_id, dealer.name);

    dealer.locations?.forEach(location => {
      if (location.exact_account_id) linkedAccounts.set(location.exact_account_id, `${dealer.name} - ${location.name}`);
    });

    return linkedAccounts;
  }, new Map<string, string>());

export const useLinkedExactAccountsQuery = (isEnabled: boolean) =>
  useTypedQuery({
    queryKey: DealersDashboardQueryKeys.list,
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data.dealers,
    select: collectLinkedAccounts,
    enabled: isEnabled
  });
